function initialState() {
    return {
        currentLanguage: window.myCurrentLanguage ?? 1,
        currentLanguageIso: window.myCurrentLocale ?? 'en',
        languages: [],
        all_languages: [],
        loading: false
    }
}

const getters = {
    currentLanguage:    state => state.currentLanguage,
    currentLanguageIso: state => state.currentLanguageIso,
    languages:          state => state.languages,
    all_languages:      state => state.all_languages,
    loading:            state => state.loading
}

const actions = {
    fetchLanguages({ commit }) {
        let prefix = axios.defaults.baseURL.includes('api') ? '/' : '/api/';
        axios.get(prefix+'language')
            .then(response => {
                commit('setLanguages', response.data.data);
            })
        axios.get(prefix+'language-all')
            .then(response => {
                commit('setAllLanguages', response.data.data);
            })
    },
    setCurrentLanguageIso({ commit }, data) {
        commit('setCurrentLanguageIso', data);
    },
    setCurrentLanguage({ commit }, data) {
        commit('setCurrentLanguage', data);
    },
    setLanguages({ commit }, data) {
        commit('setLanguages', data);
    },
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setCurrentLanguage(state, data) {
        state.currentLanguage = data;
    },
    setCurrentLanguageIso(state, data) {
        state.currentLanguageIso = data;
    },
    setLanguages(state, data) {
        state.languages = data;
    },
    setAllLanguages(state, data) {
        state.all_languages = data;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
